import { connect } from 'react-redux';

import ListItem from '../components/ListItem';

import { getAvailableInventory } from '../../order/selectors';

export default connect(
  (state, ownProps) => ({
    availableInventory: ownProps.isProduct
      ? getAvailableInventory(state, null, ownProps.item)
      : null,
  })
)(ListItem);
